import type { ComponentProps } from "react";
import { Loader } from "@/components/motion/loader";
import { SelectTrigger as BaseSelectTrigger } from "@/components/ui/select";
import { useI18n } from "@/locales/i18n-provider";
import { cn } from "@/utils";

export type SelectTriggerProps = ComponentProps<typeof BaseSelectTrigger> & {
  loading?: boolean;
  loadingLabel?: string;
};

export function SelectTrigger({ children, className, disabled, loading = false, loadingLabel, ...props }: SelectTriggerProps) {
  const { t } = useI18n();
  const resolvedLoadingLabel = loadingLabel ?? t("select.loading");
  return (
    <BaseSelectTrigger
      {...props}
      aria-busy={loading || undefined}
      className={cn(loading && "[&>svg:last-child]:hidden", className)}
      disabled={disabled || loading}
    >
      {children}
      {loading ? <Loader className="shrink-0 text-muted-foreground" label={resolvedLoadingLabel} size={14} /> : null}
    </BaseSelectTrigger>
  );
}

export {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectValue,
} from "@/components/ui/select";
